import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { BingoApp } from "./components/bingo/BingoApp";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<BingoApp />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
